export function checkPasswordStrength(password: string){

    let score = 1;

    if (!password) return 0;
    
    if (password.length < 8) return 0;

    if (!/\d/.test(password)) return 0;

    if (!(/[a-z]/.test(password) && /[A-Z]/.test(password))) return 0;

    if (password.length >= 12) score++;

    const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    if (specialChars.test(password)){
        score++;
    }

    return score;



}